<template>
  <div class="flex flex-col h-full">
    <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
      <template slot="title" v-if="!loading">{{ item.member.first + ' ' + item.member.last }}<small class="text-xs ml-2">Application Submission</small>
      </template>
    </page-header>

    <tabs :tabs="tabs" :active="startTab" @setTab="setActiveTab" ref="tabs"></tabs>

    <div class="flex xl:flex-row lg:flex-col md:flex-col sm:flex-col flex-grow">
      <div class="xl:w-3/4 lg:w-full md:w-full sm:w-full px-4 sm:px-6 lg:px-6 bg-white border-r border-gray-400 bg-gray-200">
        <div class="mt-2 grid grid-cols-12 row-gap-0 col-gap-4 sm:grid-cols-12" v-if="!loading" v-show="activeTab === 'details'">
          <div class="sm:col-span-6">
            <table class="w-full mb-4 internal-table">
              <thead>
              <tr>
                <th colspan="2">Application Details</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="w-32">ID</td>
                <td>{{ item.friendly_id_display }}</td>
              </tr>
              <tr>
                <td class="w-32">Form</td>
                <td>{{ item.application_form.name }}</td>
              </tr>
              <tr>
                <td>Limit</td>
                <td>${{ item.application_form.limit.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
              </tr>
              <tr>
                <td>Remaining</td>
                <td>${{ item.values.remaining.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
              </tr>
              <tr>
                <td>Supplier</td>
                <td>{{ item.supplier ? item.supplier.name : item.supplier_other + ' (Other)' }}</td>
              </tr>
              <tr>
                <td>Amount</td>
                <td>${{ item.amount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
              </tr>
              <tr v-if="item.gst">
                <td>GST</td>
                <td>${{ item.gst.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
              </tr>
              <tr>
                <td>Supplier Order Confirmation</td>
                <td>
                  <a :href="confirmationURL + '/submissions/' + item.id" target="_blank" class="text-default-500">/submissions/{{ item.id }}</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="sm:col-span-6">
            <table class="w-full mb-4 internal-table">
              <thead>
              <tr>
                <th colspan="2">Member Details</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Name</td>
                <td>
                  <router-link :to="'/members/'+item.member.id+'/view'" class="text-default-500">{{ item.member.full_name }}</router-link>
                </td>
              </tr>
              <tr v-if="item.member.other_first">
                <td>Other Name <small v-if="item.member.other_name_preferred">(Preferred)</small></td>
                <td>
                  <router-link :to="'/members/'+item.member.id+'/view'" class="text-default-500">{{ item.member.other_first + ' ' + item.member.other_last }}</router-link>
                </td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ item.member.email }}</td>
              </tr>
              <tr>
                <td>Mobile</td>
                <td>{{ item.member.mobile }}</td>
              </tr>
              <tr>
                <td>Address</td>
                <td>{{ item.member.address }} {{ item.member.suburb }} {{ item.member.state }} {{ item.member.postcode }}</td>
              </tr>
              <tr>
                <td>Current BSB</td>
                <td>{{ item.member.account_bsb }}</td>
              </tr>
              <tr>
                <td>Current Account</td>
                <td>{{ item.member.account_number }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="sm:col-span-12" v-if="elements">
            <table class="w-full mb-4 internal-table">
              <thead>
              <tr>
                <th colspan="2">Form</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(element, index) in elements" :key="index">
                <template v-if="element.type === 'fileUpload'">
                  <td class="w-1/4">{{ element.label }}</td>
                  <td>
                                            <span class="text-sm block" v-for="(element, fileIndex) in element.value" :key="fileIndex">
                                                <a :href="S3URL+'/'+element.path" target="_blank" class="text-gray-800 text-default-500 text-xs">{{ element.filename }}</a>
                                            </span>
                  </td>
                </template>
                <template v-else-if="element.type === 'dateInput'">
                  <td>{{ element.label }}</td>
                  <td>
                    <span class="text-xs" v-if="element.value">{{ new Date(element.value) | moment('DD/MM/YYYY') }}</span>
                    <span class="text-xs" v-else></span>
                  </td>
                </template>
                <template v-else-if="element.type === 'checkboxInput'">
                  <td>{{ element.label }}</td>
                  <td>
                    <span class="text-xs" v-if="element.value && Array.isArray(element.value)">{{ element.value.join(', ') }}</span>
                    <span class="text-xs" v-else-if="element.value && !Array.isArray(element.value)">{{ element.value }}</span>
                    <span class="text-xs" v-else></span>
                  </td>
                </template>
                <template v-else>
                  <td>{{ element.label }}</td>
                  <td><span class="text-xs">{{ element.value }}</span></td>
                </template>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="sm:col-span-12" v-if="item.supplier_invoices">
            <table class="w-full mb-4 internal-table">
              <thead>
              <tr>
                <th colspan="2">Supplier Invoices</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(invoice, index) in item.supplier_invoices" :key="index">
                <td class="font-normal" style="font-weight: normal!important">
                  <a :href="S3URL+'/'+invoice.path" target="_blank" class="text-gray-800 hover:text-default-500 text-xs">{{ invoice.filename }}</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <tasks v-if="!loading"
          v-show="activeTab === 'tasks'"
          :id="item.id"
          :tasks="item.tasks"
          model="ApplicationSubmission"
        />
        <notes v-if="!loading"
          v-show="activeTab === 'notes'"
          :id="item.id"
          :notes="item.notes"
          model="ApplicationSubmission"
        />
        <activity v-if="!loading && item.status_logs"
          v-show="activeTab === 'activity'"
          :activity="item.status_logs"
        />
      </div>
      <div class="xl:w-1/4 lg:w-full md:w-full sm:w-full px-4 sm:px-6 lg:px-6">
        <div class="mt-2 grid grid-cols-1 row-gap-2 col-gap-4 sm:grid-cols-12" v-if="!loading">
          <div class="sm:col-span-12">
            <table class="w-full internal-table">
              <thead>
              <tr>
                <th colspan="2">Status</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="w-1/2">Application Status</td>
                <td class="text-right" v-if="item.application_status">
                                        <span class="mr-1" :style="'background: ' + item.application_status.colour.background + '; color: ' + item.application_status.colour.text + '; padding: 2px 6px; border-radius: 5px;'">
                                            {{ item.application_status.name }}
                                        </span>
                </td>
                <td v-else></td>
              </tr>
              <tr>
                <td>FAS Status</td>
                <td class="text-right" v-if="item.fas_status">
                                        <span class="mr-1" :style="'background: ' + item.fas_status.colour.background + '; color: ' + item.fas_status.colour.text + '; padding: 2px 6px; border-radius: 5px;'">
                                            {{ item.fas_status.name }}
                                        </span>
                </td>
                <td v-else></td>
              </tr>
              <tr>
                <td>Supplier Status</td>
                <td class="text-right" v-if="item.supplier_status">
                                        <span class="mr-1" :style="'background: ' + item.supplier_status.colour.background + '; color: ' + item.supplier_status.colour.text + '; padding: 2px 6px; border-radius: 5px;'">
                                            {{ item.supplier_status.name }}
                                        </span>
                </td>
                <td v-else></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="sm:col-span-12">
            <table class="w-full internal-table">
              <thead>
              <tr>
                <th colspan="2">Dates</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="w-1/2">Date Lodged</td>
                <td class="text-right">
                  <span class="mr-1">{{ item.lodged_at | moment('DD/MM/YYYY') }}</span>
                </td>
              </tr>
              <tr>
                <td class="w-1/2">Date Processed</td>
                <td class="text-right">
                  <span class="mr-1" v-if="item.processed_at">{{ item.processed_at | moment('DD/MM/YYYY') }}</span>
                  <span class="mr-1" v-else>N/A</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-for="(payment, index) in item.payment_file_payments" class="sm:col-span-12" :key="index">
            <table class="w-full internal-table">
              <thead>
              <tr>
                <th colspan="2">Payment</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="w-1/2">Date Sent</td>
                <td class="text-right">
                  <span class="mr-1">{{ payment.created_at | moment('DD/MM/YYYY') }}</span>
                </td>
              </tr>
              <tr>
                <td class="w-1/2">Method</td>
                <td class="text-right">
                  <span class="mr-1">{{ payment.method }}</span>
                </td>
              </tr>
              <tr>
                <td class="w-1/2">BSB</td>
                <td class="text-right">
                  <span class="mr-1">{{ payment.bsb }}</span>
                </td>
              </tr>
              <tr>
                <td class="w-1/2">Account</td>
                <td class="text-right">
                  <span class="mr-1">{{ payment.account_number }}</span>
                </td>
              </tr>
              <tr>
                <td class="w-1/2">Status</td>
                <td class="text-right">
                  <span class="mr-1">{{ payment.status }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="sm:col-span-12">
            <table class="w-full internal-table">
              <thead>
              <tr>
                <th colspan="2">Meta</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Sent to Xero</td>
                <td class="text-right">
                    <span class="mr-1" v-if="item.meta.xero">
                        <a :href="`https://go.xero.com/AccountsPayable/View.aspx?InvoiceID=${item.meta.xero}`" target="_blank" class="text-default-500">View</a>
                    </span>
                  <span class="mr-1" v-else>
                    No
                  </span>
                </td>
              </tr>
              <tr>
                <td>Sent for Payment</td>
                <td class="text-right">
                                        <span class="mr-1" v-if="item.meta.payment">
                                            Yes
                                        </span>
                  <span class="mr-1" v-else>
                                            No
                                        </span>
                </td>
              </tr>
              <tr>
                <td>Sent to MYOB</td>
                <td class="text-right"><span class="mr-1">{{ item.meta.myob ? 'Yes' : 'No' }}</span></td>
              </tr>
              <tr>
                <td>Supplier Email Sent</td>
                <td class="text-right">
                                        <span class="mr-1" v-if="item.meta.supplier_notified_at">
                                            {{ new Date(item.meta.supplier_notified_at) | moment('DD/MM/YYYY h:mm a') }}
                                        </span>
                  <span v-else>
                                            Never
                                        </span>
                </td>
              </tr>
              <tr>
                <td>Last Updated</td>
                <td class="text-right">
                  <span class="mr-1">{{ new Date(item.meta.updated_at) | moment('DD/MM/YYYY h:mm a') }}</span></td>
              </tr>
              <tr>
                <td>Created At</td>
                <td class="text-right">
                  <span class="mr-1">{{ new Date(item.meta.created_at) | moment('DD/MM/YYYY h:mm a') }}</span></td>
              </tr>
              <tr v-if="item.meta.created_by">
                <td>Created By</td>
                <td class="text-right">
                  <span class="mr-1">{{ item.meta.created_by.first + ' ' + item.meta.created_by.last }}</span></td>
              </tr>
              <tr v-if="item.meta.browser">
                <td>Browser</td>
                <td class="text-right"><span class="mr-1">{{ item.meta.browser }}</span></td>
              </tr>
              <tr v-if="item.meta.device">
                <td>Device</td>
                <td class="text-right"><span class="mr-1">{{ item.meta.device }}</span></td>
              </tr>
              <tr v-if="item.analytics">
                <td>Analytics</td>
                <td class="text-right"><span class="mr-1">{{ item.analytics ? 'Yes' : 'No' }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <SendToXeroModal v-if="showSendToXeroModal" @close="showSendToXeroModal = false">
      <div>
        <p class="mb-2">Enter the GST for this invoice/receipt, leave blank for no GST</p>
        <input-text class="sm:col-span-3"
          name="budget"
          dollar="true"
          v-model="gstAmount"
        />
        <table v-if="gstAmount && computedAmountSubjectToGst" class="mt-3 w-full">
          <tr>
            <td class="font-bold">Subject to GST:</td>
            <td class="text-right">${{ computedAmountSubjectToGst.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
          </tr>
          <tr>
            <td class="font-bold">Not Subject to GST:</td>
            <td class="text-right">${{ ((item.amount - parseFloat(gstAmount)) - computedAmountSubjectToGst).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
          </tr>
          <tr>
            <td class="font-bold">GST:</td>
            <td class="text-right">${{ (parseFloat(gstAmount)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
          </tr>
          <tr>
            <td class="font-bold border-t border-black">Total:</td>
            <td class="text-right border-t border-black">${{ item.amount }}</td>
          </tr>
        </table>
      </div>
      <template #actions>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button type="button"
            class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-default-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-default-700 focus:outline-none focus:border-default-700 focus:shadow-outline-default transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="sendToXero"
          >
            Submit
           </button>
         </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button type="button"
            class="inline-flex justify-center w-full border border-gray-500 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="showSendToXeroModal = false"
          >
            Cancel
          </button>
        </span>
      </template>
    </SendToXeroModal>
    <SendPaymentModal v-if="showSendPaymentModal" @close="showSendPaymentModal = false">
      <div v-if="item.amount === 0">
        <p>The amount needs to be greater than $0</p>
      </div>
      <div v-else-if="!hasToAccountDetails">
        <p>
          Bank Account Details are missing for
          <strong class="text-default-500">
            <a v-if="item.supplier_id && item.supplier.name !== 'Member'" :href="`/configuration/suppliers/${item.supplier_id}/edit`" target="_blank">{{ item.supplier.name }}</a>
            <a v-else :href="`/members/${item.member_id}/edit`" target="_blank">{{ item.member.full_name }}</a>
          </strong>, you must add them before you can send a payment.
        </p>
      </div>
      <div v-else-if="!hasFromAccountDetails">
        <p>
          Funding Bank Account Details are missing for the
          <strong>{{ item.application_form.name }}</strong> form, you must add them before you can send a payment.
        </p>
      </div>
      <table v-else class="text-sm w-full">
        <tr>
          <td class="font-bold pr-4 pb-2">To:</td>
          <td class="pb-2 pl-1">{{ item.supplier_id && item.supplier.name !== 'Member' ? item.supplier.name : (item.account_name ? item.account_name : item.member.full_name) }}</td>
        </tr>
        <tr>
          <td class="font-bold pr-4 pb-2 whitespace-no-wrap">To
            <span v-if="item.supplier_id && item.supplier.name !== 'Member' && item.supplier.payment_method">BPay </span>Account:
          </td>
          <td class="pb-2 pl-1" v-if="item.supplier_id && item.supplier.name !== 'Member' && item.supplier.payment_method === 'bank'">
            <strong>BSB:</strong> {{ item.supplier.account_bsb }}
            <strong>Account:</strong> {{ item.supplier.account_number }}
          </td>
          <td class="pb-2 pl-1" v-else-if="item.supplier_id && item.supplier.name !== 'Member' && item.supplier.payment_method === 'bpay'">
            <div class="flex space-x-2">
              <strong class="whitespace-no-wrap">Biller Code:</strong><span>{{ item.supplier.bpay_biller_code }}</span><strong>CRN:</strong><span><input type="text" v-model="payeeCrn" class="border border-gray-500 px-1 w-full"/></span>
            </div>
          </td>
          <td class="pb-2 pl-1" v-else>
            <strong>BSB:</strong> {{ item.member.account_bsb }}
            <strong>Account:</strong> {{ item.member.account_number }}
          </td>
        </tr>
        <tr>
          <td class="font-bold pr-4 pb-2">Amount:</td>
          <td class="pb-2 pl-1">${{ item.amount }}</td>
        </tr>
        <tr>
          <td class="font-bold pr-4 pb-2">Reference:</td>
          <td class="pb-2 pl-1">{{ item.friendly_id_display }}</td>
        </tr>
        <tr>
          <td class="font-bold pr-4 pb-1">Payee Reference:</td>
          <td class="pb-1">
            <input type="text" v-model="payeeReference" class="border border-gray-500 px-1 w-full" maxlength="18"/>
          </td>
        </tr>
        <tr>
          <td class="font-bold pr-4 pb-1">Send to Xero:</td>
          <td class="pb-1 py-1 flex items-center justify-start">
            <span v-if="hasXeroTenant">
              <input type="checkbox" v-model="postPaymentToXero" />
            </span>
            <span v-else class="pb-1 text-xs text-red-500">You need to select a Xero Account for the form</span>
          </td>
        </tr>
      </table>
      <template v-if="postPaymentToXero">
        <p class="mb-2">Enter the GST for this invoice/receipt, leave blank for no GST</p>
        <input-text class="sm:col-span-3"
          name="budget"
          dollar="true"
          v-model="gstAmount"
        />
        <table v-if="gstAmount && computedAmountSubjectToGst" class="mt-3 w-full">
          <tr>
            <td class="font-bold">Subject to GST:</td>
            <td class="text-right">${{ computedAmountSubjectToGst.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
          </tr>
          <tr>
            <td class="font-bold">Not Subject to GST:</td>
            <td class="text-right">${{ ((item.amount - parseFloat(gstAmount)) - computedAmountSubjectToGst).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
          </tr>
          <tr>
            <td class="font-bold">GST:</td>
            <td class="text-right">${{ (parseFloat(gstAmount)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
          </tr>
          <tr>
            <td class="font-bold border-t border-black">Total:</td>
            <td class="text-right border-t border-black">${{ item.amount }}</td>
          </tr>
        </table>
      </template>
      <template #actions>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" v-if="item.amount > 0 && hasToAccountDetails && hasFromAccountDetails">
          <button type="button"
            class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-default-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-default-700 focus:outline-none focus:border-default-700 focus:shadow-outline-default transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="sendPayment"
          >
            Submit
           </button>
         </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button type="button"
            class="inline-flex justify-center w-full border border-gray-500 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="showSendPaymentModal = false"
          >
            Cancel
          </button>
        </span>
      </template>
    </SendPaymentModal>
  </div>
</template>

<script>
import Tabs from '../../mixins/Tabs'
import axios from 'axios'
import Notes from '@/components/Notes'
import Tasks from '@/components/Tasks'
import Activity from '@/components/Activity'
import SendPaymentModal from '@/views/applicationForms/modals/SendPaymentModal.vue'
import SendToXeroModal from '@/views/applicationForms/modals/SendToXeroModal.vue'

export default {
  name: 'SubmissionView',
  props: {
    id: { required: true },
    return: { required: false, default: '/submissions' },
    page: { required: false, default: 'submissions' }
  },
  components: {
    SendToXeroModal,
    SendPaymentModal,
    Tasks,
    Notes,
    Activity
  },
  mixins: [
    Tabs
  ],
  data: function () {
    return {
      tabs: [
        {
          name: 'Details',
          slug: 'details'
        },
        {
          name: 'Tasks',
          slug: 'tasks'
        },
        {
          name: 'Notes',
          slug: 'notes'
        },
        {
          name: 'Activity',
          slug: 'activity'
        }
      ],
      startTab: null,
      loading: true,
      item: {},
      pageActions: {},
      S3URL: process.env.VUE_APP_S3_URL,
      confirmationURL: process.env.VUE_APP_CONFIRMATION_URL,
      showSendPaymentModal: false,
      showSendToXeroModal: false,
      payeeReference: '',
      payeeCrn: '',
      postPaymentToXero: true,
      gstAmount: null
    }
  },
  methods: {
    getData: function () {
      this.$Progress.start()

      axios.get(process.env.VUE_APP_API_URL + '/submissions/' + this.id)
        .then(response => {
          this.item = response.data

          this.pageActions = {
            buttons: [
              {
                label: 'Send to Xero',
                icon: 'cloud-upload-alt',
                iconClass: 'text-blue-500',
                type: 'method',
                method: 'handleShowToXeroModal',
                display: this.$store.getters.permissions.indexOf('submissions.xero') !== -1 && !this.item.meta.xero
              },
              {
                label: 'Send Payment',
                icon: 'cloud-upload-alt',
                iconClass: 'text-blue-500',
                type: 'method',
                method: 'handleShowSendPaymentModal',
                display: (this.$store.getters.permissions.indexOf('submissions.send-payment') !== -1 && !this.item.meta.payment) || (this.$store.getters.permissions.indexOf('submissions.send-payment') !== -1 && this.item.meta.payment && this.item.payment_file_payments.length && (this.item.payment_file_payments[0].status === 'Failed' || this.item.payment_file_payments[0].status === 'Cancelled')) && this.item.can_send_payment
              },
              {
                label: 'Send Supplier Email',
                icon: 'paper-plane',
                iconClass: 'text-blue-700',
                type: 'method',
                method: 'sendSupplierEmail',
                display: this.$store.getters.permissions.indexOf('submissions.edit') !== -1
              },
              {
                label: 'Edit',
                icon: 'edit',
                type: 'router-link',
                link: '/submissions/' + this.id + '/edit',
                iconClass: 'text-gray-700',
                display: !!(this.$store.getters.permissions.indexOf('submissions.edit') !== -1 || this.$store.getters.nimdarepus)
              },
              {
                label: 'Cancel',
                icon: 'times',
                iconClass: 'text-red-500',
                type: 'method',
                method: 'cancel'
              }
            ],
            additional: [
              {
                label: 'Delete',
                icon: 'trash-alt',
                type: 'method',
                method: 'deleteModal',
                iconClass: 'text-red-500',
                display: !!(this.$store.getters.permissions.indexOf('submissions.destroy') !== -1 || this.$store.getters.nimdarepus)
              }
            ]
          }

          if (this.item.submission) {
            this.item.submission.elements.forEach(element => {
              if (element.type === 'fileUpload') {
                if (!element.value.length) {
                  element.value = [element.value]
                }
              }
            })
          }

          this.$Progress.finish()
          this.loading = false
        })
        .catch(() => {
          this.$Progress.finish()
          this.loading = false
        })
    },
    methodHandler: function (method) {
      this[method]()
    },
    actionHandler: function (data) {
      this[data.method](data)
    },
    cancel: function () {
      this.$router.push(this.return)
    },
    handleShowSendPaymentModal: function () {
      this.postPaymentToXero = this.hasXeroTenant;
      this.gstAmount = this.item.gst

      this.payeeReference = this.item.friendly_id_display
      this.payeeCrn = ''
      this.showSendPaymentModal = true
    },
    handleShowToXeroModal: function () {
      this.gstAmount = this.item.gst
      this.showSendToXeroModal = true
    },
    sendPayment: function () {
      this.$store.commit('TOGGLE_BACKDROP', { open: true })

      axios.post(process.env.VUE_APP_API_URL + '/submissions/' + this.id + '/payment', {
        reference: this.payeeReference,
        crn: this.payeeCrn,
        xero: this.postPaymentToXero
      }).then(response => {
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Success',
          text: response.data.message,
          duration: 5000
        })

        this.getData()
      }).catch(error => {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: error.response.data.message,
          duration: 5000
        })
      }).finally(() => {
        this.showSendPaymentModal = false
        this.$store.commit('TOGGLE_BACKDROP', { open: false })
      })
    },
    sendToXero: function () {
      this.$store.commit('TOGGLE_BACKDROP', { open: true })

      axios.post(process.env.VUE_APP_API_URL + '/submissions/' + this.id + '/xero', {
        gst: this.gstAmount
      }).then(response => {
        if (response.data.success) {
          this.$notify({
            group: 'main',
            type: 'success',
            title: 'Success',
            text: response.data.message,
            duration: 5000
          })

          this.getData()
        } else {
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: response.data.message,
            duration: 5000
          })
        }
      }).catch(error => {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: error.response.data.message,
          duration: 5000
        })
      }).finally(() => {
        this.showSendToXeroModal = false
        this.gstAmount = null
        this.$store.commit('TOGGLE_BACKDROP', { open: false })
      })
    },
    sendSupplierEmail: function () {
      this.$store.commit('TOGGLE_BACKDROP', { open: true })

      axios.post(process.env.VUE_APP_API_URL + '/submissions/' + this.id + '/email-supplier').then(response => {
        if (response.data.success) {
          this.$notify({
            group: 'main',
            type: 'success',
            title: 'Success',
            text: response.data.message,
            duration: 5000
          })
        } else {
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: response.data.message,
            duration: 5000
          })
        }
        this.$store.commit('TOGGLE_BACKDROP', { open: false })
      })
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    elements() {
      if (this.item.submission && this.item.submission.elements) {
        return this.item.submission.elements
      } else if (this.item.application_form && this.item.application_form.form) {
        return this.item.application_form.form.elements
      } else {
        return null
      }
    },
    hasToAccountDetails() {
      if (this.item.supplier_id && this.item.supplier.name !== 'Member') {
        return this.item.supplier.payment_method !== null
      }

      return !!(this.item.member_id && this.item.member.account_bsb && this.item.member.account_number)
    },
    hasFromAccountDetails() {
      return this.item.application_form.funding_account_bsb && this.item.application_form.funding_account_number
    },
    hasXeroTenant() {
      return !!this.item.application_form.xero_tenant
    },
    computedAmountSubjectToGst() {
      if (this.gstAmount) {
        return (this.gstAmount / 0.1)
      }

      return this.item.amount
    },
  }
}
</script>

<style scoped>

</style>
